import { fetchDataPromise } from '../index';

export const getOrganizationData = (resolve, reject, token, orgSeq) => {
    let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/getmodelorganization';
    let requestBody = {}
    if (orgSeq) {
        requestBody.filterData = orgSeq
    }
    let req = new Request(requestURL, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    });

    fetchDataPromise(req, 'getmodelorganization', resolve, reject)

}

export const getOrganizationGroupData = (resolve, reject, orgSeq, selectGroup, token) => {
    let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/getmodelorganizationgroup';
    let requestBody = {}
    if (orgSeq) {
        requestBody.selectSiteData = orgSeq;
        requestBody.selectGroupData = selectGroup;
    }
    let req = new Request(requestURL, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    });

    fetchDataPromise(req, 'getmodelorganizationgroup', resolve, reject)

}

export const deleteOrganizationData = (resolve, reject, orgId, token) => {
    let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/deletemodelorganization?orgId=' + orgId;
    let req = new Request(requestURL, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type': 'application/json'
        }
    });

    fetchDataPromise(req, 'deletemodelorganization', resolve, reject)
}

export const saveOrgGroupData = (resolve, reject, saveOrgData, mod, token, accountInfo) => {
    let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/savemodelorganizationgroup?saveMod=' + mod + '&account=' + accountInfo.account;
    let req = new Request(requestURL, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(saveOrgData)
    });

    fetchDataPromise(req, 'savemodelorganizationgroup', resolve, reject)
}

export const deleteOrgGroupData = (resolve, reject, groupId, token) => {
    let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/deletemodelorganizationgroup?groupId=' + groupId;
    let req = new Request(requestURL, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type': 'application/json'
        }
    });

    fetchDataPromise(req, 'deletemodelorganizationgroup', resolve, reject)
}

export const getGroupList = (resolve, reject, token, orgId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/getmodelgroup', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      orgId: orgId
    })
  });

  fetchDataPromise(req, 'getGroupList', resolve, reject);
}

export const getAccountList = (resolve, reject, token, orgId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/getmodelaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      orgId: orgId
    })
  });

  fetchDataPromise(req, 'getAccountList', resolve, reject);
}

export const getDeviceList = (resolve, reject, token, orgId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/getmodeldevicelist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      orgId: orgId
    })
  });

  fetchDataPromise(req, 'getDeviceList', resolve, reject);
}

export const getSsidByGroups = (resolve, reject, token, groups) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/getmodelssidbygroups', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type' : 'application/json'
        },
        body: JSON.stringify({
            groups: groups
        })
    });

    fetchDataPromise(req, 'getSsidByGroups', resolve, reject);
}


export const getPortalList = (resolve, reject, token, site) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['model'] + '/getguestportallist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      orgId: site
    })
  });

  fetchDataPromise(req, 'getPortalList', resolve, reject);
}

export const getNetworkZoneList = (resolve, reject, token, site) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/getnetworkzonelist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      organizationId: site
    })
  });

  fetchDataPromise(req, 'getNetworkZoneList', resolve, reject);
}

export const getRadioClusterGroupList = (resolve, reject, token, seq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/groupaplist?seq=' + seq, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization': token,
      'Content-Type': 'application/json'
    },

  });
  fetchDataPromise(req, 'getRadioClusterGroupList', resolve, reject);
}